var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { inject, observer } from 'mobx-react';
import { hotkeys } from 'react-keyboard-shortcuts';

import { Label } from 'sdc-i18n-react';

import { WithHotkey } from '../hotkeys';

import './button.scss';

var classNames = require('classnames');

var handleClick = function handleClick(e) {
  e.preventDefault();
  e.stopPropagation();
};

var TheButton = inject('labelsStore')(observer(function (_ref) {
  var labelsStore = _ref.labelsStore,
      icon = _ref.icon,
      caption = _ref.caption,
      children = _ref.children,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$hotkey = _ref.hotkey,
      hotkey = _ref$hotkey === undefined ? '' : _ref$hotkey,
      _ref$as = _ref.as,
      T = _ref$as === undefined ? 'button' : _ref$as,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'secondary' : _ref$color,
      _ref$solid = _ref.solid,
      solid = _ref$solid === undefined ? false : _ref$solid,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$iconClassName = _ref.iconClassName,
      iconClassName = _ref$iconClassName === undefined ? '' : _ref$iconClassName,
      _ref$iconStyle = _ref.iconStyle,
      iconStyle = _ref$iconStyle === undefined ? {} : _ref$iconStyle,
      active = _ref.active,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ['labelsStore', 'icon', 'caption', 'children', 'title', 'hotkey', 'as', 'color', 'solid', 'className', 'iconClassName', 'iconStyle', 'active', 'disabled', 'onClick']);

  return React.createElement(
    T,
    _extends({}, props, { 'data-ts': labelsStore.lastUpdate, className: classNames('sdc-action-button', T === 'button' && 'btn', T === 'button' && (solid ? 'btn-' + color : 'btn-outline-' + color), className, active && 'active', disabled && 'disabled'), onClick: disabled ? handleClick : onClick, title: labelsStore.labelFor(title, props) + (hotkey ? ' [' + hotkey + ']' : '') }),
    icon && React.createElement('i', { className: iconClassName + ' fa fa-fw fa-' + icon, style: iconStyle }),
    caption !== undefined && React.createElement(Label, _extends({ className: 'caption', value: caption }, props)),
    children
  );
}));

/**
  @class a generic button component, with classes 'sdc-action-button' and 'active' / 'disabled' applied.
  Any additional parameters not mentioned below are passed on to the tooltip.
  @param {string} [icon] - the optional FA icon to render
  @param {string} [caption] - the optional I18N key for the caption to render
  @param {string} [title] - the I18N key for the tooltip to render
  @param {string} [className] - any class(es) to apply in addition to 'sdc-action-button'
  @param {boolean} [active] - a flag to activate the 'active' class
  @param {boolean} [disabled] - a flag to activate the 'disabled' class
  @param {string} [iconClassName] - any class(es) to apply to the icon
  @param {object} [iconstyle] - any styl(s) to apply to the icon
  @param [children] - any children to render
*/
export var Button = function Button(props) {
  return React.createElement(WithHotkey, _extends({}, props, {
    render: function render(props) {
      return React.createElement(TheButton, props);
    } }));
};